var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 h-100",staticStyle:{"overflow":"hidden"}},[_c('canvas',{ref:"canvasRef",style:(_vm.getCanvasSize),attrs:{"id":"myCanvas"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }